import { Invoker } from "@/core/endpoints/requests/_invoker";
import { BaseRecord } from "@/core/endpoints/domain/_base_record";
import { CourseAttendanceResponse } from "@/core/endpoints/responses/courseAttendance_response";

import {
  BaseRequest,
  ResponseCallback,
} from "@/core/endpoints/requests/_base_request";

export class CourseAttendanceRequest extends BaseRequest<
  CourseAttendanceResponse,
  null,
  BaseRecord
> {
  seFormId:any;
  createResponse(): CourseAttendanceResponse {
    return new CourseAttendanceResponse();
  }

  EdStudId = "";
  EdCourseId = "";

  //   Get Data
  invokeGetStudentAttendance(
    me: any,
    callback: ResponseCallback<CourseAttendanceResponse>
  ) {
    this.getFormSeID()
    Invoker.doInvokeGetAlertNote<CourseAttendanceResponse>(
      me,
      this.createResponse(),
      true,
      `api/course/v1/Attendance/GetStudentAttendance/?EdStudId=${this.EdStudId}&SeForm=${this.seFormId}`,
      this.toJson(me),
      (me: any, CourseAttendanceResponse: CourseAttendanceResponse) => {
        callback(me, CourseAttendanceResponse);
      },
       
    );
  }

  // GetStudentCourseAbsenceDetails
  invokeGetStudentCourseAbsenceDetails(
    me: any,
    callback: ResponseCallback<CourseAttendanceResponse>
  ) {
    this.getFormSeID()
    Invoker.doInvokeGetAlertNote<CourseAttendanceResponse>(
      me,
      this.createResponse(),
      true,
      `api/course/v1/Attendance/GetStudentCourseAbsenceDetails/?EdStudId=${this.EdStudId}&EdCourseId=${this.EdCourseId}&SeForm=${this.seFormId}`,
      this.toJson(me),
      (me: any, CourseAttendanceResponse: CourseAttendanceResponse) => {
        callback(me, CourseAttendanceResponse);
      },
       
    );
  }

  toJson(me: any): any {
    const json = super.toJson(me);

    if (this.EdStudId != "") {
      json.EdStudId = this.EdStudId;
    }

    if (this.EdCourseId != "") {
      json.EdCourseId = this.EdCourseId;
    }

    return json;
  }
  getFormSeID (): any {

    const selectedForms:any = localStorage.getItem('selectedForms');   // Added this line of code
    const seFormObj = JSON.parse(selectedForms).selectedForms.filter(item => item.formCodeName == "/courseAttendance");
  //console.log(seFormObj[0]?.seFormId);
if (seFormObj[0] === undefined || seFormObj[0] === null) {
    this.seFormId = 1;
} else {
    
    this.seFormId = seFormObj[0].seFormId;
    localStorage.setItem('SeFormID', String(this.seFormId));

}
  
  }
}
